module.exports = __webpack_public_path__ + "static/media/header-home-logo.8e42c263.svg";